import React from "react"
import { Button, Form } from "react-bootstrap"
import { browserHistory } from "react-router"

import { initField } from "../../lib/form-builder"
import FieldGroup from "../FieldGroup"
import apiServerApi from "../../redux/sagas/apiServerApi"
import { email, nonEmpty } from "../../lib/validators"
import { blockingFetchService } from "../../lib/blockingFetch"
import FontAwesome from "react-fontawesome"
import ProcessesStatus from "../fragments/ProcessesStatus"
import CustomBreadCrumb from "../fragments/CustomBreadCrumb"

class FormBusiness extends React.Component {

  constructor(props) {

    super(props)
    const { business } = this.props
    const isNew = !business

    this.state = {
      isNew: isNew,
      running: false,
      success: false,
      error: null,

      ...initField(this, 'name', isNew ? '' : business.name, nonEmpty),
      ...initField(this, 'businessId', isNew ? '' : business.businessId, nonEmpty),
      ...initField(this, 'contactName', isNew ? '' : business.contactName, nonEmpty),
      ...initField(this, 'phoneNumber', isNew ? '' : business.phoneNumber, nonEmpty),
      ...initField(this, 'email', isNew ? '' : business.email, email),
    }
  }

  componentDidMount() {
    if(!this.state.isNew) {
      this.validateAllValues()
    }
  }

  validateAllValues = () => {
    const { name, businessId, contactName, phoneNumber, email } = this.state
    name.validationCurrentValue()
    businessId.validationCurrentValue()
    contactName.validationCurrentValue()
    phoneNumber.validationCurrentValue()
    email.validationCurrentValue()
  }

  valid = () => {

    const { name, businessId, contactName, phoneNumber, email } = this.state
    return !!(

      name.validation &&
      name.validation.valid &&

      businessId.validation &&
      businessId.validation.valid &&

      contactName.validation &&
      contactName.validation.valid &&

      phoneNumber.validation &&
      phoneNumber.validation.valid &&

      email.validation &&
      email.validation.valid
    )
  }

  saveClicked = () => {

    if(this.valid()) {
      this.saveBusiness()
    }
    else {
      this.validateAllValues()
      this.setState({ error: 'Some fields are incorrect.' })
    }
  }

  saveBusiness = () => {

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    const { name, businessId, contactName, phoneNumber, email, isNew } = this.state

    const data = {
      name: name.value,
      businessId: businessId.value,
      contactName: contactName.value,
      phoneNumber: phoneNumber.value,
      email: email.value,
    }

    const { business } = this.props
    blockingFetchService(
      accessToken => isNew
        ? apiServerApi.saveBusiness(accessToken, data)
        : apiServerApi.updateBusiness(accessToken, business.id, data),
      _ => {
        this.setState({ success: true })
        setTimeout(() => browserHistory.push('/businesses'), 1000)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  render() {

    const { isNew, error, success, running, name, businessId, contactName, phoneNumber, email } = this.state,
    dataBreadCrumbs = [{ url: '/businesses', title: 'Businesses' }]

    return (
      <div>
        <CustomBreadCrumb activeText={ isNew ? 'New' : 'Update' } data={ dataBreadCrumbs } />

        <div className="simple-form max-width-700 mx-auto mb-20">
          <Form>

            <h3 className="text-center">
              { isNew ? 'New business' : 'Update business' }
            </h3>
            <hr />

            <FieldGroup
              label="Name"
              id="name"
              type="text"
              placeholder="Enter name"
              value={ name.value }
              onChange={ name.onChange }
              validationState={ name.validation }
              validationMessage="Name must not be empty"
              bsClass="form-control"
            />

            <FieldGroup
              label="Business ID"
              id="businessId"
              type="text"
              placeholder="Business Id"
              value={ businessId.value }
              onChange={ businessId.onChange }
              validationState={ businessId.validation }
              validationMessage="Business Id must not be empty"
              bsClass="form-control"
            />

            <FieldGroup
              label="Contact name"
              id="contactName"
              type="text"
              placeholder="Contact name"
              value={ contactName.value }
              onChange={ contactName.onChange }
              validationState={ contactName.validation }
              validationMessage="Contact name must not be empty"
              bsClass="form-control"
            />

            <FieldGroup
              label="Phone number"
              id="phoneNumber"
              type="text"
              placeholder="Phone number"
              value={ phoneNumber.value }
              onChange={ phoneNumber.onChange }
              validationState={ phoneNumber.validation }
              validationMessage="Phone number must not be empty"
              bsClass="form-control"
            />            

            <FieldGroup
              label="Email"
              id="email"
              type="email"
              placeholder="Enter email"
              value={ email.value }
              onChange={ email.onChange }
              validationState={ email.validation }
              validationMessage="Enter a valid email"
              bsClass="form-control"
            />
          </Form>

          <ProcessesStatus error={ error } running={ running } success={ success } />

          <div className="align-right mt-30">
            <Button onClick={() => browserHistory.push('/businesses')} className="w-100" disabled={ running }>
              <FontAwesome name='close' /> Cancel
            </Button>

            <Button bsStyle="success" onClick={ this.saveClicked } className="w-120 ml-10"
              disabled={ running }>
              <FontAwesome name='save' /> Save
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

export default FormBusiness



// WEBPACK FOOTER //
// ./src/components/Business/Form.js